import { useEffect, useState } from "react"
import type { SelectOptionType, SuccessFetch } from "../../../../../../../../types"
import { useApi } from "../../../../../../../../utils"

export function useTypeAddress() {
  const api = useApi()
  const [data, setData] = useState<SelectOptionType[]>([])
  const [isLoading, setLoading] = useState(true)

  useEffect(() => {
    api.get("/addresstype/")
    .then((res: SuccessFetch<{
      payload: {
        address_type_id: number
        address_type_name: string
      }[]
    }>) => { setData(res.data.payload.map(item => { return { label: item.address_type_name, value: item.address_type_id.toString() }}))})
    .catch(() => setData([]))
    .finally(() => setLoading(false))
    // eslint-disable-next-line
  }, [])

  return { data, isLoading }
}